import { AuthFormStep } from '@as-react/common-types';
import { AuthFormActionsTypes } from '../../../enums/ActionEnums';
export const initialAuthReducerState = {
    step: AuthFormStep.EMAIL,
};
export const authFormReducer = (state = initialAuthReducerState, action) => {
    switch (action.type) {
        case AuthFormActionsTypes.UPDATE_STEP_TYPE:
            return Object.assign(Object.assign({}, state), { step: action.payload.to });
        default:
            return state;
    }
};
